import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import {
    AckWaitingService,
    AdministratorsService,
    AuthenticationService,
    EmployeesService,
    EnvironmentsService,
    FileTransfersService,
    ImageService,
    LocalAgentsService,
    NotificationsService,
    PgpKeysService,
    RemotePlatformsService,
    StatisticsService,
    TagsService,
} from './http';

import {
    PermissionGuard,
    UserService,
} from './services';

@NgModule({
    imports: [
        HttpClientModule,
    ],
    declarations: [],
    providers: [
        AckWaitingService,
        AdministratorsService,
        AuthenticationService,
        EmployeesService,
        EnvironmentsService,
        FileTransfersService,
        ImageService,
        LocalAgentsService,
        NotificationsService,
        PermissionGuard,
        PgpKeysService,
        RemotePlatformsService,
        StatisticsService,
        TagsService,
        UserService,
    ],
})
export class CoreModule { }
